import { getCountryByIdRequest } from "../../data/countryApi";

function getPayloadData(response) {
  if (response?.data && !Array.isArray(response.data)) {
    return response.data;
  }

  if (response?.data?.data && !Array.isArray(response.data.data)) {
    return response.data.data;
  }

  return null;
}

export async function getCountryByIdUseCase(id) {
  if (!id) {
    throw new Error("El id es obligatorio.");
  }

  const country = getPayloadData(await getCountryByIdRequest(id));

  if (!country) {
    throw new Error("No se pudo cargar el pais.");
  }

  return country;
}
